/*
 * Constant values/variables
 */
import { TableFilters } from './schema/TableColumn'

// How long cached dashboard data (zustand stores, NaiHubDashboard's local cache) is reused
// across remounts before it's considered stale and refetched.
export const DASHBOARD_STALE_AFTER_MS = 5 * 60 * 1000

export const defaultTableFilters = {
  pagination: {
    pageIndex: 1,
    pageSize: 20,
  },
  columnFilters: [],
  sorting: [],
} as TableFilters

// textfield - 1
// location - 2   // this is for location coordinates
// caelnder-3
// images - 4
// multiselect - 5
// single select - 6
// project location - 7
// assign to - 8 // This is for investigator (single user id)
// attendees - 9 // This is for involved parties. (multiple user ids)
// approval - 10 // for for approval of preliminary investigation (HSE admin only) (single user id)

export const inputTypes = {
  1: 'text',
  2: 'location',
  3: 'datetime-local',
  4: 'image',
  5: 'checkbox',
  6: 'select',
  7: 'project location',
  8: 'assign to',
  9: 'attendees',
  10: 'approval',
  11: 'textarea',
  12: 'documents',
} as any

// Mirrors the backend's `Platform` enum exactly (values, not just labels) — every dropdown
// offering a platform choice and every API call sending `platform` should read from here
// rather than hardcoding the strings, so the two never drift out of sync again.
export const Platform = {
  WHATSAPP: 'WhatsApp',
  NAI: 'nAI',
  // API: 'API',
} as const

export type PlatformValue = (typeof Platform)[keyof typeof Platform]

export const platformOptions: { label: string; value: PlatformValue }[] = [
  { label: 'WhatsApp', value: Platform.WHATSAPP },
  { label: 'nAI', value: Platform.NAI },
  // { label: 'API', value: Platform.API },
]
